module.exports = __webpack_public_path__ + "6ac3837cdbe5d034fd9d23fffeb43b51.svg";